import { prepareChartData } from "@components/Chart/highcharts/DrawLineChart/prepareChartData";
import { SecuritiesChartDataWithDate } from "../types";

export const prepareSecuritiesData = (
  data: SecuritiesChartDataWithDate[],
  showLines: string[],
  chartColors: Record<string, string>
) => {
  const dataKeys = {
    all: "totalValue",
    bonds: "bondsValue",
    etfs: "etfsValue",
    funds: "fondsValue",
    holdings: "holdingsValue",
    derivative: "derivativeValue",
    crypto: "cryptoValue",
    comparison: "comparedValue",
  } as const;

  return prepareChartData(data, showLines, dataKeys, chartColors);
};
